// extracted by mini-css-extract-plugin
module.exports = {"noData":"NoData_noData__3ugLB","image":"NoData_image__1ec0N","message":"NoData_message__3wMXl","isRateCard":"NoData_isRateCard__2qm48"};